export const DOCES = [
  {
    id: "bolo-cenoura",
    name: "Bolo de Cenoura",
    description:
      "Bolo fofo de cenoura com uma cobertura cremosa de brigadeiro de chocolate.",
    image: "/images/bolo-cenoura.jpg",
    alt: "Bolo de cenoura artesanal com cobertura de brigadeiro de chocolate e granulado, num prato de bolo branco",
  },
  {
    id: "bolo-laranja",
    name: "Bolo de Laranja",
    description:
      "Bolo aromático com cobertura de leite condensado e laranja, finalizado com raspas.",
    image: "/images/bolo-laranja.jpg",
    alt: "Bolo de laranja artesanal com cobertura cremosa e raspas de laranja, num prato de bolo branco",
  },
  {
    id: "bolo-nuvem-chocolate",
    name: "Bolo Nuvem de Chocolate",
    description:
      "Massa de chocolate com recheio leve de brigadeiro de Nesquik e cobertura de mascarpone com leite Nido.",
    image: "/images/bolo-nuvem.jpg",
    alt: "Bolo nuvem de chocolate com cobertura de mascarpone e pérolas douradas, fatiado num prato de bolo branco",
  },
  {
    id: "pudim-leite-condensado",
    name: "Pudim de Leite Condensado",
    description:
      "Pudim cremoso de leite condensado envolvido numa deliciosa calda de caramelo.",
    image: "/images/pudim.jpg",
    alt: "Pudim de leite condensado com calda de caramelo, fatiado num prato de bolo branco",
  },
  {
    id: "bolo-abobora",
    name: "Bolo de Abóbora",
    description:
      "Um bolo macio, húmido e reconfortante, com o sabor delicado da abóbora.",
    image: "/images/abobora.jpg",
    alt: "Bolo de abóbora polvilhado com açúcar em pó, fatiado num prato de bolo branco",
  },
  {
    id: "bolo-fuba",
    name: "Bolo de Fubá",
    description: "Massa de milho tradicional.",
    image: "/images/bolo-cinema.jpg",
    alt: "Bolo de fubá dourado fatiado num prato de bolo branco",
  },
  {
    id: "bolo-cinema",
    name: "Bolo Cinema",
    description: "Massa de milho com doce de leite, cobertura cremosa e pipocas.",
    image: "/images/cinema.jpg",
    alt: "Bolo cinema de milho com doce de leite, cobertura cremosa e pipocas, fatiado num prato de bolo branco",
  },
  {
    id: "bolo-cappuccino",
    name: "Bolo Cappuccino",
    description:
      "Um bolo acolhedor inspirado nos sabores do café e do chocolate.",
    image: "/images/cappuccino.jpg",
    alt: "Bolo cappuccino com creme de chocolate e recheio cremoso, fatiado num prato de bolo branco",
  },
  {
    id: "brigadeiros",
    name: "Brigadeiros",
    description:
      "Brigadeiros artesanais, cremosos e preparados em diferentes sabores.",
    image: "/images/brigadeiros.jpg",
    alt: "Prato com brigadeiros artesanais de chocolate e de coco em formas de papel",
  },
  {
    id: "biscoitos-amanteigados",
    name: "Biscoitos Amanteigados",
    description:
      "Biscoitos delicados e crocantes, perfeitos para acompanhar um café ou chá.",
    image: "/images/biscoitos.jpg",
    alt: "Prato com biscoitos amanteigados caseiros de vários formatos sobre um pano de linho",
  },
];
